import { useEffect } from 'react';
import { useUserSetupStore } from '@sib/auth';
import { useOrganizationFromSearch } from '@sib/utils';
import { useFileManagerFileUploadStore } from '@spendbrain/stores/fileUploadStore';

export const useOrganizationSetup = () => {
  const { setOrganizationId, setOrganizationName } = useUserSetupStore();
  const organization = useOrganizationFromSearch();

  useEffect(() => {
    if (!organization) return;
    setOrganizationId(organization.id);
    setOrganizationName(organization.name);
  }, [organization, setOrganizationName, setOrganizationId]);
};

export const useBeforeUnloadWarning = () => {
  const isUploading = useFileManagerFileUploadStore().getAreFilesUploading();

  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (isUploading) {
        event.preventDefault();
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isUploading]);
};
